<template>
    <div>
        <div class="content-button">
            <div class="const">
                <div class="const-a">
                    <div class="content-button-left">
                        <div @click="goToAboutUs">
                            About&nbsp;Us
                        </div>
                    </div>
                    <div class="content-button-right">

                        Contact&nbsp;&nbsp;Us:&nbsp;&nbsp;Binru&nbsp;&nbsp;Yang&nbsp;&nbsp;2872852236@qq.com

                    </div>
                </div>
                <div class="const-icp">
                    <a
                        class="icp-link"
                        href="https://beian.miit.gov.cn/#/Integrated/index"
                        target="_blank"
                        rel="noopener noreferrer"
                    >蜀ICP备2025157670号-1</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
const goToAboutUs = () => {
    router.push('/aboutus')
}
</script>
<style scoped lang="scss">
* {

    width: 100vw;


    .content-button {
        width: 100vw;
        height: 100px;
        background-color: black;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

        .const {
            /* width: 80%; */
            width: 568px;
            /* border: 1px solid red; */
            height: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            row-gap: 0;
            box-sizing: border-box;
            transform: translateY(-8px);

            .const-a {
                /* width: 80%; */
                /* border: 1px solid red; */
                width: 568px;
                display: flex;
                align-items: center;

                .content-button-left {
                    /* margin: 30px 140px 39px 436px; */
                    margin-right: 140px;
                    width: 71px;
                    height: 22px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: left;
                    /* border: 1px solid red; */
                    /* .text-t {
                        width: 71px;
                        height: 22px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF;
                        text-align: left;
                    } */


                }

                .content-button-right {
                    /* margin: 30px 436px 39px 0px; */
                    width: 357px;
                    height: 22px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: left;
                    /* border: 1px solid red; */
                    /* .text-y {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF
                    } */

                }
            }

            .const-icp {
                width: 100%;
                text-align: center;
                line-height: 1.2;
                margin-top: -2px;
            }

            .icp-link {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 12px;
                color: #FFFFFF;
                text-decoration: none;
                line-height: 1.2;
            }

            .icp-link:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>